import { type AxiosResponse } from "axios"
import { endpoints } from "@/common/services/api"
import httpClient from "@/common/http/interceptors"
import Util from "@/common/util"

const providerService = {
  fetchUseCases: (): Promise<AxiosResponse> => {
    return httpClient.get(
      Util.getRestApiUrl(
        `${endpoints.provider.usecases.get.path}?excludeDeleted=true`,
        endpoints.provider.usecases.get.system
      )
    )
  }
}

export default providerService
